import type { ComponentType } from "react";
import { BadgeCheck, Clapperboard, Users, type LucideIcon } from "lucide-react";
import { PatientManagementMock } from "./PatientManagementMock";
import { VideoLibraryMock } from "./VideoLibraryMock";
import { ReviewContentMock } from "./ReviewContentMock";

/** The Quilt Pro screens, in order, shared by the features page and the provider page tour. */
export interface ProFeature {
    id: string;
    icon: LucideIcon;
    badge: string;
    title: string;
    text: string;
    /** The live screen; reserve is the viewport height to keep free around it */
    Mock: ComponentType<{ reserve?: string }>;
}

export const PRO_FEATURES: ProFeature[] = [
    {
        id: "patients",
        icon: Users,
        badge: "Patient management",
        title: "All your patients, in one clear view",
        text: "Add and invite patients, keep their details up to date, and organize them into groups. Filter by condition, location, tags or sign-up status to find the people you need.",
        Mock: PatientManagementMock,
    },
    {
        id: "videos",
        icon: Clapperboard,
        badge: "Video library",
        title: "Every video, from idea to approval",
        text: "Browse every video made for your patients, see the concept and storyboard behind each one, and review it before it goes out.",
        Mock: VideoLibraryMock,
    },
    {
        id: "review",
        icon: BadgeCheck,
        badge: "Content review",
        title: "Approve every video, one by one",
        text: "Watch each new video, approve or reject it, and check the condition, symptom and emotional-purpose tags it was made with.",
        Mock: ReviewContentMock,
    },
];
